import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.common.PasswordValidationSection', {
    passwordValidationTextLength: 'Use 8 or more characters',
    passwordValidationTextUseNumber: 'Use a number (e.g. 1234)',
    passwordValidationTextUseUpperLowerCase: 'Upper and lower case letters (e.g. Aa)',
    passwordValidationTextUseSymbol: 'Use a symbol (e.g. !@#$)',
});
